import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/estructura-organizacional/grupos';

const formatGroups = (data) => {
  if (Array.isArray(data)) {
    return data.map((g) => formatGroups(g));
  }
  return ({
    ...data,
    name: data.name.split(' - ').shift(),
  });
};
/**
 * GET Grupos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getGrupos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatGroups(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Grupo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getGrupo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return formatGroups(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Grupo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGrupo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatGroups(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Grupo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGrupo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return formatGroups(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Grupo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteGrupo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
